module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/10-9f386ae4ccc851593b53b45b5c0e7f5d.jpg";